import { useEffect, useState } from "react";
import useAuth from "../hook/useAuth";
import { put_Lesson } from "../services/Lesson";
import { PleasewaitPopup } from "./PleasewaitPopup";

type EditLessonProps = {
    showPopup: boolean;
    setShowPopup: (value: boolean) => void;
    setRefreshLessonList: (value: boolean) => void;
    data: any;
}

export const EditLesson = ({ showPopup, setShowPopup, setRefreshLessonList, data }: EditLessonProps) => {
    const { auth }: any = useAuth();
    const [lessonTitle, setLessonTitle] = useState<string>("");
    const [lessonDiscription, setLessonDiscription] = useState<string>("");
    const [showPleasewait, setShowPleasewait] = useState<boolean>(false);

    useEffect(() => {
        if (showPopup) {
            document.body.classList.add("overflow-hidden");
        } else {
            document.body.classList.remove("overflow-hidden");
        }

        return () => {
            document.body.classList.remove("overflow-hidden");
        };
    }, [showPopup]);

    useEffect(() => {
        if (data) {
            setLessonTitle(data?.title);
            setLessonDiscription(data?.description);
        }
    }, [data])

    if (!showPopup) return null;

    const handleOnSave = () => {
        setShowPleasewait(true);
        put_Lesson({
            ...data,
            title: lessonTitle,
            description: lessonDiscription,
            updatedAt: new Date().toLocaleString(),
            updatedBy: auth?.givenname,
        }, auth?.id)
            .then((res) => {
                setShowPleasewait(false);
                setShowPopup(false);
                setRefreshLessonList(true);
            })
            .catch((error) => {
                console.error(error)
            })
    }

    return (
        <>
            <div className="fixed inset-0 z-[9999999] flex items-center justify-center bg-black/50 p-10">
                <div className="bg-white w-full max-w-3xl rounded-md shadow-lg max-h-[90vh] flex flex-col">

                    <div className="px-6 py-4 border-b w-full flex justify-between items-center">
                        <h2 className="text-lg font-medium">Edit lesson</h2>
                        <button
                            onClick={() => {
                                setShowPopup(false)
                            }}
                            className="text-gray-500"
                        >
                            <span className="material-symbols-outlined text-2xl">
                                close
                            </span>
                        </button>
                    </div>


                    <div>
                        <div className="px-6 pt-6 space-y-4">

                            <label className="font-medium">Lesson Title</label>
                            <input
                                type="text"
                                placeholder="Title"
                                className="w-full mt-2 border rounded px-3 py-2 text-sm focus:outline-none focus:ring focus:ring-primary"
                                value={lessonTitle}
                                onChange={(e) => setLessonTitle(e.target.value)}
                            />

                        </div>

                        <div className="px-6 py-6 space-y-4">
                            <label className="font-medium">Lesson Description</label>
                            <textarea
                                rows={3}
                                placeholder="Description"
                                className="w-full mt-2 border rounded px-3 py-2 text-sm focus:outline-none focus:ring focus:ring-primary"
                                value={lessonDiscription}
                                onChange={(e) => setLessonDiscription(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="px-6 py-4 border-t flex justify-end space-x-3">

                        <button
                            className={`px-6 py-2 ${!lessonTitle ? "bg-gray-300 text-white cursor-not-allowed" : "bg-primary text-white cursor-pointer"}  font-medium rounded`}
                            disabled={!lessonTitle ? true : false}
                            onClick={handleOnSave}
                        >
                            Save
                        </button>
                    </div>
                </div>
            </div >
            <PleasewaitPopup showPopup={showPleasewait} />
        </>
    )
}